// 플랫폼 정의 파일 어디서 관리할 지 지정 필요
export enum PlatformType {
  FLEXG = "flexg",
  CAFE24 = "cafe24",
  BLOGPAY = "blogpay",
  MAKESHOP = "makeshop",
  SHORTSWORKS = "shortsworks",
}
